<script lang="ts">
  import LottieSuccess from './lottie/LottieSuccess.svelte';

  export let copyText: string;
  export let className = '';

  let isCopying = false;

  function copy() {
    isCopying = true;
    navigator.clipboard.writeText(copyText);
  }
</script>

<button class="{className} relative" on:click={copy}>
  <span class:invisible={isCopying}>
    {#if $$slots.default}
      <slot />
    {:else}
      {copyText}
    {/if}
  </span>

  {#if isCopying}
    <div class="copy-icon-container">
      Copied
      <LottieSuccess className="inline-block" on:complete={() => (isCopying = false)} />
    </div>
  {/if}
</button>

<style lang="postcss">
  .copy-icon-container {
    @apply absolute left-1/2 text-grey flex;

    transform: translate(-50%, -100%);
  }
</style>
